export const management = {
  routes: [
    {
      path: "/management/legal-document-template-category",
      component: () => import("../management-library-legal-document-template-category-view"),
    },
    {
      path: "/management/legal-document-template",
      component: () => import("../management-library-legal-document-template-view"),
    },

    {
      path: "/management/legal-document-template/edit/:id",
      component: () => import("../management-library-legal-document-template-form"),
    },
    {
      path: "/management/legal-document-template/create",
      component: () => import("../management-library-legal-document-template-form"),
    },
  ],
};
export const workspace = {
  routes: [
    {
      path: "/workspace/legal-document-template",
      component: () => import("../workspace-library-legal-document-template-view"),
    },

    {
      path: "/workspace/legal-document-template/edit/:id",
      component: () => import("../workspace-library-legal-document-template-form"),
    },
    {
      path: "/workspace/legal-document-template/create",
      component: () => import("../workspace-library-legal-document-template-form"),
    },
    {
      path: "/workspace/legal-document-template/create-with-library-item/:libraryItemId",
      component: () => import("../workspace-library-legal-document-template-form"),
    },
  ],
};

export const gdpr = {
  routes: [
    {
      path: "/gdpr/legal-document-template",
      component: () => import("../gdpr-legal-document-template-view"),
    },
    {
      path: "/gdpr/legal-document-template/:id",
      component: () => import("../legal-document-template-detail"),
    },

    {
      path: "/gdpr/legal-document-review/:id",
      component: () => import("../legal-document-review-detail"),
    },
  ],
};

export const kvkk = {
  routes: [
    {
      path: "/kvkk/legal-document-template",
      component: () => import("../kvkk-legal-document-template-view"),
    },
    {
      path: "/kvkk/legal-document-template/:id",
      component: () => import("../legal-document-template-detail"),
    },

    {
      path: "/kvkk/legal-document-review/:id",
      component: () => import("../legal-document-review-detail"),
    },
  ],
};

export const ddo = {
  routes: [
    {
      path: "/ddo/legal-document-template",
      component: () => import("../ddo-legal-document-template-view"),
    },
    {
      path: "/ddo/legal-document-template/:id",
      component: () => import("../legal-document-template-detail"),
    },

    {
      path: "/ddo/legal-document-review/:id",
      component: () => import("../legal-document-review-detail"),
    },
  ],
};
